module.exports = __webpack_public_path__ + "img/resolved-status.dc3dd50d.svg";